import React, { Component } from 'react';
import moment from 'moment';

import UrbioticaSensorSettingsForm from './UrbioticaSensorSettingsForm';

import { defaultSorter, dateSorter } from './Helpers';
import UrbioticaSensorsModel from './UrbioticaSensorsModel';
import UserModel from './UserModel';

import { Table, Badge, Row, Col, Statistic, Popconfirm, Divider, message, Typography } from 'antd';

class UrbioticaSensorsTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    urbioticaSensorSettingsFormData: null
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  expandedRowRender(record) {
    return (
      <div>
        <Row style={{ marginBottom: 20 }}>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Napětí baterie [V]"
              value={record.node_battery} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Teplota [°C]"
              value={record.temperature} />
          </Col>
        </Row>
      </div >
    );
  }

  render() {

    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Lokalita',
      dataIndex: 'parkingLocationName',
      key: 'parkingLocationName',
      width: 250,
      sorter: (a, b) => defaultSorter(a.parkingLocationName, b.parkingLocationName)
    }, {
      title: 'Urbiotica ID',
      dataIndex: 'urbioticaID',
      key: 'urbioticaID',
      width: 100,
      sorter: (a, b) => defaultSorter(a.urbioticaID, b.urbioticaID)
    }, {
      title: 'Typ zprávy',
      dataIndex: 'messageType',
      key: 'messageType',
      width: 70,
      filters: [{
        text: 'vehicle_ctrl',
        value: 'vehicle_ctrl',
      }, {
        text: 'vehicle',
        value: 'vehicle',
      }],
      onFilter: (value, record) => record.messageType === value,
    }, {
      title: 'Místo',
      dataIndex: 'placeID',
      key: 'placeID',
      width: 75,
      defaultSortOrder: 'ascend',
      sorter: (a, b) => defaultSorter(a.placeID, b.placeID)
    }, {
      title: 'Poslední komunikace',
      dataIndex: 'lastTechInfoStateChange',
      sorter: (a, b) => dateSorter(a.lastTechInfoStateChange, b.lastTechInfoStateChange),
      render: (text, record) => {
        if (moment(record.lastTechInfoStateChange) <= moment().subtract(120, "minutes")) {
          return (
            <Badge
              status="error"
              text={moment(text).format('L LTS')}
              title="Poslední komunikace před více než 2 hodinami" />
          );
        } else if (moment(record.lastTechInfoStateChange) <= moment().subtract(60, "minutes")) {
          return (
            <Badge
              status="warning"
              text={moment(text).format('L LTS')}
              title="Poslední komunikace před více než 60 minutami" />
          );
        } else {
          return (
            <Badge
              status="success"
              text={moment(text).format('L LTS')}
              title="Vpořádku" />
          );
        }
      }
    }, {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => {
        if (record.occ == -1) {
          return "Down"
        } else {
          if (typeof (record.status) == 'undefined') {
            return "Up"
          } else {
            return record.status
          }
        }
      }
    }, {
      title: 'Poslední změna stavu',
      dataIndex: 'lastStateChange',
      key: 'lastStateChange',
      width: 185,
      sorter: (a, b) => dateSorter(a.lastStateChange, b.lastStateChange),
      render: (text, record) => {
        return (moment(record.lastStateChange).format('L LTS'))
      }
    }, {
      title: 'Stav',
      dataIndex: 'occ',
      key: 'occ',
      width: 150,
      filters: [{
        text: 'OBSAZENO',
        value: 1,
      }, {
        text: 'VOLNO',
        value: 0,
      }, {
        text: 'Kalibrace / neznámý stav / chyba',
        value: -1,
      }],
      filteredValue: filteredInfo.occ || null,
      onFilter: (value, record) => { return (parseInt(record.occ) === parseInt(value)) ? true : false },
      sorter: (a, b) => defaultSorter(a.occ, b.occ),
      render: (text, record) => {
        if (record.occ === 1) {
          return (
            <Badge
              status="error"
              text={"OBSAZENO"}
              title="Obsazeno" />
          );
        } else if (record.occ === 0) {
          return (
            <Badge
              status="success"
              text={"VOLNO"}
              title="Volno" />
          );
        } else {
          return (
            <Badge
              color="#6d6d6d"
              text={"Kalibrace / neznámý stav / chyba"}
              title="Kalibrace / neznámý stav / chyba" />
          )
        }
      }
    }, {
      title: 'Upozornění',
      dataIndex: 'reportsEnabled',
      key: 'reportsEnabled',
      width: 130,
      filters: [{
        text: 'ZAPNUTO',
        value: true,
      }, {
        text: 'VYPNUTO',
        value: false,
      }],
      filteredValue: filteredInfo.reportsEnabled || null,
      onFilter: (value, record) => {
        return ((record.reportsEnabled === value)) ? true : false
      },
      render: (text, record) => {
        if (record.reportsEnabled === true) {
          return (
            <Badge
              status="success"
              text="ZAPNUTO" />
          );
        } else {
          return (
            <Badge
              status="error"
              text="VYPNUTO" />
          );
        }
      }
    }, {
      title: 'Akce',
      key: 'Action',
      width: 200,
      render: (text, record) => {
        if (UserModel.isInRoles(['ADMIN', 'URBIOTICA_SENSORS_WRITE'])) {
          return (
            <div>
              <a onClick={(e) => {
                this.setState({
                  urbioticaSensorSettingsFormData: record
                });
              }}>Nastavení</a>
              <Divider type="vertical" />
              <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
                this.props.onRemoveRow
                  ? this.props.onRemoveRow(record._id)
                  : null;
              }} okText="Ano" cancelText="Ne">
                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
              </Popconfirm>
            </div>
          );
        }
      }
    }];

    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : '_id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          onChange={this.handleChange}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
              ? parseInt(localStorage.getItem('table_pageSize'))
              : 10,
            onShowSizeChange: (current, size) => {
              localStorage.setItem('table_pageSize', size);
            }
          }}
          expandedRowRender={this.expandedRowRender.bind(this)}
          style={{ border: '0px' }} />
        <UrbioticaSensorSettingsForm
          type="modal"
          modalVisible={this.state.urbioticaSensorSettingsFormData === null ? false : true}
          initialValues={this.state.urbioticaSensorSettingsFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ urbioticaSensorSettingsFormData: null });
          }}
          onSuccess={(form, values) => {
            let data = Object.assign({}, this.state.urbioticaSensorSettingsFormData, values)
            UrbioticaSensorsModel.patch(this.state.urbioticaSensorSettingsFormData._id, data)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  urbioticaSensorSettingsFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
      </div>
    );
  }
}

export default UrbioticaSensorsTable;


// WEBPACK FOOTER //
// ./src/components/UrbioticaSensorsTable.js